/**
 * Keeps the Arrival Date block in sync with the selected variant.
 *
 * When a variant changes, Horizon's variant-picker.js fetches the updated
 * section HTML from the server and dispatches a `variant:update` event
 * on the variant-picker element (bubbles up to the .shopify-section).
 *
 * The server-rendered response already contains the correct arrival message for
 * the new variant (special order flag, inventory_quantity). We find the updated
 * [data-arrival-content] in that HTML by matching data-block-id and swap it in.
 *
 * Mirrors the pattern used by product-price.js / ProductPrice custom element.
 */

function initArrivalDate() {
  document.querySelectorAll('.awe-arrival-date[data-block-id]').forEach((container) => {
    const section = container.closest('.shopify-section, dialog');
    if (!section) return;

    section.addEventListener('variant:update', (event) => {
      const blockId = container.dataset.blockId;

      const newContainer = event.detail?.data?.html?.querySelector(
        `.awe-arrival-date[data-block-id="${blockId}"]`
      );
      if (!newContainer) return;

      const current = container.querySelector('[data-arrival-content]');
      const updated = newContainer.querySelector('[data-arrival-content]');
      if (current && updated) {
        current.replaceWith(updated);
      }
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initArrivalDate);
} else {
  initArrivalDate();
}
